import styled, { css } from "styled-components";
import tw from "twin.macro";

import { Button, ButtonProps } from "../Button";
import { Body2 } from "../Typography";

export const StyledValueButtonLabel = styled(Body2)`
  opacity: 60%;
  margin-right: 2px;
`;

StyledValueButtonLabel.displayName = "StyledValueButtonLabel";

export const StyledValueButtonValue = styled(Body2)``;

StyledValueButtonValue.displayName = "StyledValueButtonValue";

interface IStyledValueButton extends ButtonProps {
  $active?: boolean;
}

export const StyledValueButton = styled(Button)<IStyledValueButton>`
  ${(props) =>
    props.$active &&
    css`
      ${StyledValueButtonLabel},
      ${StyledValueButtonValue} {
        ${tw`tw-pointer-events-none`}
        color: var(--color-theme-900) !important;
      }

      svg {
        fill: var(--color-primary);
      }
    `}

  ${(props) =>
    props.$active !== true &&
    css`{
    &:hover {
      ${StyledValueButtonLabel},
      ${StyledValueButtonValue} {
        ${tw`tw-pointer-events-none`}
        color: var(--color-theme-900) !important;
      }
    }
  `}
`;

StyledValueButton.displayName = "StyledValueButton";
